import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getMentorsList } from '../actions/listActions';
import { getUmpInfo, getUmpiresList, updateMentorsMentees } from '../actions/umpireActions';
import MentorTable from '../components/MentorTable';

const mapDispatchToProps = dispatch => {
  return {
    getMentorsList: seasonId => {
      dispatch(getMentorsList(seasonId));
    },
    getUmpiresList: seasonId => {
      dispatch(getUmpiresList(seasonId));
    },
    getUmpInfo: memberId => {
      dispatch(getUmpInfo(memberId));
    },
    updateMentorsMentees: (mentorId, menteeId, column, seasonId, operation) => {
      dispatch(updateMentorsMentees(mentorId, menteeId, column, seasonId, operation));
    }
  };
};

const mapStateToProps = state => ({
  fetchingMentorsList: state.lists.fetchingMentorsList,
  mentorsList: state.lists.mentorsList,
  seasons: state.seasons.seasons,
  seasonsList: state.seasons.seasonsList,
  umpiresSeason: state.lists.umpiresSeason,
  umpiresSeasonList: state.lists.umpiresSeasonList,
  fetchingUmpiresList: state.lists.fetchingUmpiresList,
  umpiresList: state.umpires.umpiresList,
  fetchingStatus: state.umpires.fetchingStatus,
  userSeason: state.user.userSeason
});

const MentorTableContainer = withRouter(connect(mapStateToProps, mapDispatchToProps)(MentorTable));
export default MentorTableContainer;



// WEBPACK FOOTER //
// ./src/containers/MentorTableContainer.js